import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
const FAQS = [{
  q: "¿Cómo recibiré el material?",
  a: "Inmediatamente después del pago recibirás un correo con el acceso para descargar todos los tomos y bonos en formato PDF."
}, {
  q: "¿El contenido sirve para cualquier país?",
  a: "Sí. Está desarrollado con criterios clínicos aplicables a odontólogos de toda Hispanoamérica."
}, {
  q: "¿Necesito ser especialista?",
  a: "No. El sistema está pensado tanto para odontólogos generales que desean afrontar casos de mayor complejidad como para profesionales que buscan organizar y estandarizar su proceso de trabajo."
}, {
  q: "¿Los archivos son descargables?",
  a: "Sí. Todos los tomos, protocolos y bonos son archivos PDF de alta calidad que podrás consultar desde cualquier dispositivo o imprimir cuando lo necesites."
}, {
  q: "¿Es un pago único?",
  a: "Sí. Pagas una sola vez y el acceso es tuyo para siempre. No existen mensualidades ni renovaciones."
}, {
  q: "¿Qué pasa si no es lo que esperaba?",
  a: "Estás protegido por nuestra garantía de 7 días. Si el contenido no cumple con tus expectativas, solo debes solicitar el reembolso y te devolveremos el 100% de tu dinero."
}];
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-[var(--cream)] px-4 py-14" data-id="element-82" data-mp="11w7fba3181zv">
      <div className="mx-auto max-w-2xl" data-id="element-83" data-mp="16np6j6f96o7n">
        <h2 className="text-center font-serif-display text-2xl font-extrabold text-gray-900 sm:text-3xl" data-id="element-84" data-mp="16oqta85msz57">
          ❓ Preguntas Frecuentes
        </h2>

        <div className="mt-8 space-y-3" data-id="element-85" data-mp="wy5p8576v2ew">
          {FAQS.map((f, i) => <div key={f.q} className="overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm" data-id="element-86" data-mp="ww1n9ssuodh9" data-mpi={i}>
              <button onClick={() => setOpen(open === i ? null : i)} className="flex w-full items-center justify-between gap-3 p-4 text-left" aria-expanded={open === i} data-id="element-87" data-mp="j0qvwpdteahn">
                <span className="text-sm font-bold text-gray-900 sm:text-base" data-id="element-88" data-mp="2kvn5ylrw93v0">{f.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-[var(--brand)] transition-transform ${open === i ? "rotate-180" : ""}`} data-id="element-89" data-mp="2fwammb08eex6" />
              </button>
              <AnimatePresence initial={false} data-id="element-90" data-mp="38kzdzibhj5vq">
                {open === i && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-91" data-mp="33nfxebrbeh0m">
                    <p className="px-4 pb-4 text-sm leading-relaxed text-gray-600" data-id="element-92" data-mp="1n8o7c5hn5luh">{f.a}</p>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}